// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function makeResponseTransformer1(f) {
  return [f];
}

function makeResponseTransformer2(f0, f1) {
  return [
          f0,
          f1
        ];
}

function makeResponseTransformer3(f0, f1, f2) {
  return [
          f0,
          f1,
          f2
        ];
}

function makeResponseTransformer4(f0, f1, f2, f3) {
  return [
          f0,
          f1,
          f2,
          f3
        ];
}

function makeResponseTransformer5(f0, f1, f2, f3, f4) {
  return [
          f0,
          f1,
          f2,
          f3,
          f4
        ];
}

function makeRequestTransformer1(f) {
  return [f];
}

function makeRequestTransformer2(f0, f1) {
  return [
          f0,
          f1
        ];
}

function makeRequestTransformer3(f0, f1, f2) {
  return [
          f0,
          f1,
          f2
        ];
}

function makeRequestTransformer4(f0, f1, f2, f3) {
  return [
          f0,
          f1,
          f2,
          f3
        ];
}

function makeRequestTransformer5(f0, f1, f2, f3, f5) {
  return [
          f0,
          f1,
          f2,
          f3,
          f5
        ];
}

function Headers_fromObj(prim) {
  return prim;
}

function Headers_fromDict(prim) {
  return prim;
}

var $$Headers = {
  fromObj: Headers_fromObj,
  fromDict: Headers_fromDict
};

var Instance;

var Agent;

exports.$$Headers = $$Headers;
exports.makeResponseTransformer1 = makeResponseTransformer1;
exports.makeResponseTransformer2 = makeResponseTransformer2;
exports.makeResponseTransformer3 = makeResponseTransformer3;
exports.makeResponseTransformer4 = makeResponseTransformer4;
exports.makeResponseTransformer5 = makeResponseTransformer5;
exports.makeRequestTransformer1 = makeRequestTransformer1;
exports.makeRequestTransformer2 = makeRequestTransformer2;
exports.makeRequestTransformer3 = makeRequestTransformer3;
exports.makeRequestTransformer4 = makeRequestTransformer4;
exports.makeRequestTransformer5 = makeRequestTransformer5;
exports.Instance = Instance;
exports.Agent = Agent;
/* No side effect */
